export default function formFunctions(formSelector) {
  formSelector.querySelectorAll('[required="required"]').forEach((requiredField) => {
    requiredField.classList.add('validate-required');
    requiredField.removeAttribute('required');
  });

  function toggleFormControlValidationState(validateRequiredField, isValid, errorClass, parent) {
    if (isValid) {
      validateRequiredField.classList.remove('is-invalid');
      parent.classList.remove(errorClass);
    } else {
      validateRequiredField.classList.add('is-invalid');
      parent.classList.add(errorClass);
    }
  }

  function validateRequired(formFieldParentSelectorClass, errorClass) {
    let isValid = true;
    const girlsAndBoysDayContentElement = document.getElementById('c5060');
    const isGirlsAndBoysDayForm = girlsAndBoysDayContentElement !== null
      && girlsAndBoysDayContentElement.contains(formSelector);
    const geburtsDatumGirlsBoysDayField = isGirlsAndBoysDayForm
      ? girlsAndBoysDayContentElement.querySelector('.powermail_date')
      : null;

    formSelector.querySelectorAll('.validate-required').forEach((validateRequiredField) => {
      let fieldIsValid = true;
      const type = validateRequiredField.getAttribute('type');
      const parent = validateRequiredField.parentElement;
      const formGroup = validateRequiredField.closest('.form-group');
      if (type === 'radio') {
        const fcValid = parent.parentElement.parentElement.querySelector(`input[type="${type}"]:checked`);
        const validateRadio = validateRequiredField.parentElement.parentElement.parentElement;
        const validateRadioParent = formGroup ?? validateRadio.parentElement;
        toggleFormControlValidationState(validateRadio, fcValid, errorClass, validateRadioParent);
        fieldIsValid = !!fcValid;
      } else if (type === 'checkbox') {
        const fcValid = parent.parentElement.querySelector(`input[type="${type}"]:checked`);
        const validateCheck = validateRequiredField;
        const validateCheckParent = formGroup ?? validateCheck.parentElement.parentElement.parentElement;
        toggleFormControlValidationState(validateCheck, fcValid, errorClass, validateCheckParent);
        fieldIsValid = !!fcValid;
      } else if (
        type === 'date'
        && isGirlsAndBoysDayForm
        && geburtsDatumGirlsBoysDayField !== null
        && validateRequiredField === geburtsDatumGirlsBoysDayField
        && geburtsDatumGirlsBoysDayField.value !== ''
      ) {
        geburtsDatumGirlsBoysDayField.parentNode.parentNode.classList.remove('powermail_field_error');
        const geburtsDatumGirlsBoysDay = new Date(geburtsDatumGirlsBoysDayField.value);
        const compareDate = new Date();
        compareDate.setMonth(3);
        compareDate.setDate(24);
        compareDate.setFullYear(compareDate.getFullYear() - 12);
        // If age is under 12 on April 03 of current year, activate form if event is this year
        if (geburtsDatumGirlsBoysDay > compareDate) {
          if (geburtsDatumGirlsBoysDayField.parentNode.getElementsByClassName('invalid-feedback').length > 0) {
            geburtsDatumGirlsBoysDayField.parentNode.getElementsByClassName('invalid-feedback')[0].remove();
          }
          if (!geburtsDatumGirlsBoysDayField.parentNode.parentNode.classList.contains('powermail_field_error')) {
            geburtsDatumGirlsBoysDayField.parentNode.parentNode.classList.add('powermail_field_error');
          }
          if (!geburtsDatumGirlsBoysDayField.classList.contains('is-invalid')) {
            geburtsDatumGirlsBoysDayField.classList.add('is-invalid');
          }
          const invalidFeedbackElement = document.createElement('div');
          invalidFeedbackElement.classList.add('invalid-feedback');
          invalidFeedbackElement.classList.add('js-feedback');
          invalidFeedbackElement.innerHTML = 'Leider bist du dieses Jahr noch zu jung für den Girls’ und Boys’ Day. Schau nächstes Jahr wieder vorbei – wir freuen uns schon auf dich!';
          geburtsDatumGirlsBoysDayField.parentNode.append(invalidFeedbackElement);
          const fieldValUntrimmed = validateRequiredField.value;
          const fieldVal = fieldValUntrimmed.trim();
          const fcValid = fieldVal.length > 0;
          toggleFormControlValidationState(validateRequiredField, fcValid, errorClass, parent);
          fieldIsValid = false;
        } else {
          if (geburtsDatumGirlsBoysDayField.parentNode.getElementsByClassName('invalid-feedback').length > 0) {
            geburtsDatumGirlsBoysDayField.parentNode.getElementsByClassName('invalid-feedback')[0].remove();
          }
          geburtsDatumGirlsBoysDayField.parentNode.parentNode.classList.remove('powermail_field_error');
          geburtsDatumGirlsBoysDayField.classList.remove('is-invalid');
          const fieldValUntrimmed = validateRequiredField.value;
          const fieldVal = fieldValUntrimmed.trim();
          const fcValid = fieldVal.length > 0;
          toggleFormControlValidationState(validateRequiredField, fcValid, errorClass, parent);
          fieldIsValid = fcValid;
        }
      } else {
        const fieldValUntrimmed = validateRequiredField.value;
        const fieldVal = fieldValUntrimmed.trim();
        const fcValid = fieldVal.length > 0;
        toggleFormControlValidationState(validateRequiredField, fcValid, errorClass, parent);
        fieldIsValid = fcValid;
      }
      if (!fieldIsValid && formGroup !== null && formGroup.querySelector('.invalid-feedback') === null && type !== 'radio') {
        if (formGroup.querySelector('.block-label') !== null) {
          const label = formGroup.querySelector('.block-label').textContent;
          const labelWithoutAsterisk = label.replace('*', '');
          if (labelWithoutAsterisk !== null) {
            const invalidFeedbackElement = document.createElement('div');
            invalidFeedbackElement.classList.add('invalid-feedback');
            invalidFeedbackElement.classList.add('js-feedback');
            invalidFeedbackElement.innerHTML = `Bitte füllen Sie das Feld <em>${labelWithoutAsterisk}</em> aus.`;
            parent.append(invalidFeedbackElement);
          }
        }
      } else if (!fieldIsValid && formGroup !== null && formGroup.querySelector('.invalid-feedback') === null && type === 'radio') {
        if (formGroup.querySelector('.block-label') !== null) {
          const label = formGroup.querySelector('.block-label').textContent;
          const labelWithoutAsterisk = label.replace('*', '');
          if (labelWithoutAsterisk !== null) {
            const invalidFeedbackElement = document.createElement('div');
            invalidFeedbackElement.classList.add('invalid-feedback');
            invalidFeedbackElement.classList.add('js-feedback');
            invalidFeedbackElement.innerHTML = `Bitte füllen Sie das Feld <em>${labelWithoutAsterisk}</em> aus.`;
            formGroup.append(invalidFeedbackElement);
          }
        }
      }
      if (!fieldIsValid) {
        isValid = false;
      }
    });
    return isValid;
  }

  function validate() {
    const errorClass = 'powermail_field_error';
    formSelector.querySelectorAll('.form-group').forEach((formGroup) => {
      formGroup.classList.remove(errorClass);
      const jsFeedback = formGroup.querySelector('.js-feedback');
      if (jsFeedback !== null) {
        jsFeedback.remove();
      }
    });

    const isValid = validateRequired(formSelector, errorClass);
    const firstValidationError = formSelector.getElementsByClassName('powermail_field_error');
    if (!isValid && firstValidationError.length > 0) {
      const firstErrorElement = firstValidationError[0];
      window.scroll({top: firstErrorElement.offsetTop, left: 0, behavior: 'smooth'});
    }
    return isValid;
  }

  // Hide hebamme textfield and optional in label
  const hebammeTextFieldLabel = document.querySelector('[for=powermail_field_marker_01]');

  // Show hebamme textfield if radio button is yes, make required
  const radioButtonHebammeYes = document.querySelector('#powermail_field_hebamme_2');
  const hebammeTextField = document.querySelector('#powermail_field_marker_01');

  function showRadioButtonHebammeTextField() {
    if (this.checked) {
      hebammeTextFieldLabel.parentElement.classList.remove('d-none');
      hebammeTextField.setAttribute('aria-required', 'true');
      hebammeTextField.classList.add('validate-required');
      hebammeTextFieldLabel.childNodes[1].classList.add('d-none');
    }
  }

  // Hide hebamme textfield if radio button is no, make optional
  const radioButtonHebammeNo = document.querySelector('#powermail_field_hebamme_1');

  function hideRadioButtonHebammeTextField() {
    if (this.checked) {
      if (!hebammeTextFieldLabel.parentElement.classList.contains('d-none')) {
        hebammeTextFieldLabel.parentElement.classList.add('d-none');
        hebammeTextField.setAttribute('aria-required', 'false');
        if (hebammeTextField.classList.contains('validate-required')) {
          hebammeTextField.classList.remove('validate-required');
        }
      }
    }
  }

  // Hide kinderarzt textfield and optional in label
  const kinderarztTextFieldLabel = document.querySelector('[for=powermail_field_marker_02]');

  // Show kinderarzt textfield if radio button is yes, make required
  const radioButtonKinderarztYes = document.querySelector('#powermail_field_kinderarzt_2');
  const kinderarztTextField = document.querySelector('#powermail_field_marker_02');

  function showRadioButtonKinderarztTextField() {
    if (this.checked) {
      kinderarztTextFieldLabel.parentElement.classList.remove('d-none');
      kinderarztTextField.setAttribute('aria-required', 'true');
      kinderarztTextField.classList.add('validate-required');
      kinderarztTextFieldLabel.childNodes[1].classList.add('d-none');
    }
  }

  // Hide kinderarzt textfield if radio button is no, make optional
  const radioButtonKinderarztNo = document.querySelector('#powermail_field_kinderarzt_1');

  function hideRadioButtonKinderarztTextField() {
    if (this.checked) {
      if (!kinderarztTextFieldLabel.parentElement.classList.contains('d-none')) {
        kinderarztTextFieldLabel.parentElement.classList.add('d-none');
        kinderarztTextField.setAttribute('aria-required', 'false');
        if (kinderarztTextField.classList.contains('validate-required')) {
          kinderarztTextField.classList.remove('validate-required');
        }
      }
    }
  }

  const onlineAnmeldungZurGeburtForm = document.getElementById('c8486');

  if (onlineAnmeldungZurGeburtForm !== null) {
    // Change field schwangerschaftswoche with min-length of 34 to type number to allow arrows
    const fieldSchwangerschaftsWoche = document.querySelector('#powermail_field_schwangerschaftswoche');
    if (fieldSchwangerschaftsWoche !== null) {
      fieldSchwangerschaftsWoche.setAttribute('type', 'number');
    }
    if (hebammeTextFieldLabel !== null) {
      hebammeTextFieldLabel.parentElement.classList.add('d-none');
      hebammeTextFieldLabel.childNodes[1].classList.add('d-none');
    }
    if (radioButtonHebammeYes !== null && hebammeTextField !== null) {
      radioButtonHebammeYes.addEventListener('change', showRadioButtonHebammeTextField);
    }
    if (radioButtonHebammeNo !== null) {
      radioButtonHebammeNo.addEventListener('change', hideRadioButtonHebammeTextField);
    }
    if (kinderarztTextFieldLabel !== null) {
      kinderarztTextFieldLabel.parentElement.classList.add('d-none');
      kinderarztTextFieldLabel.childNodes[1].classList.add('d-none');
    }
    if (radioButtonKinderarztYes !== null && kinderarztTextField !== null) {
      radioButtonKinderarztYes.addEventListener('change', showRadioButtonKinderarztTextField);
    }
    if (radioButtonKinderarztNo !== null) {
      radioButtonKinderarztNo.addEventListener('change', hideRadioButtonKinderarztTextField);
    }
  }

  function formSubmitEvent(event) {
    const isValid = validate();
    if (!isValid) {
      event.preventDefault();
    } else {
      const formActions = formSelector.querySelector('.powermail_fieldwrap_type_submit');
      if (formActions !== null) {
        const formButton = formActions.querySelector('.btn');
        if (formButton !== null) {
          formButton.style.display = 'none';
        }
        const submitButton = formActions.querySelector('input[type="submit"]');
        if (submitButton !== null) {
          submitButton.style.display = 'block';
          submitButton.disabled = true;
        }
      }
    }
    return isValid;
  }

  formSelector.addEventListener('submit', formSubmitEvent);
}
